// extracted by mini-css-extract-plugin
export var animationContainer = "_nn-0";
export var footer = "_nn-1";
export var gray = "_nn-2";
export var lineItem = "_nn-3";
export var lineItemImage = "_nn-4";
export var lineItemInfo = "_nn-5";
export var lineItemText = "_nn-6";
export var lineItems = "_nn-7";
export var modalContent = "_nn-8";
export var options = "_nn-9";
export var orderName = "_nn-a";
export var refundAmount = "_nn-b";